// 状态管理方法
import { observable, action, flow } from 'mobx';
// 引入Serv
import Serv from './SelectBindCardCodeServ';

export default class SelectBindCardCodeMod {
  /**
   * 绑定卡号
   */
  workAuthBind = flow(function* (params) {
    try {
      const result = yield Serv.workAuthBind(params);
      return result;
    } catch (error) {
      return false;
    }
  });

  /**
   * 享脉-绑定卡号
   */
  xiangMaiSilent = flow(function* (params) {
    try {
      const result = yield Serv.xiangMaiSilent(params);
      return result;
    } catch (error) {
      return false;
    }
  });
}



// WEBPACK FOOTER //
// ./src/pages/Shop/WechatAuth/SelectBindCardCode/SelectBindCardCodeMod.js